<!-- <ion-app [class.white-background]="isChatIdPresent"> -->
<ion-app>
  <a *ngIf="!chatId" href="https://narratheque.io" target="_blank">
    <img class="logo ion-hide-md-down" src="../assets/logo.svg" alt="Logo" />
    <img class="logo-small ion-hide-md-up" *ngIf="!isOnChatPage" src="../assets/logo-small.svg" alt="Logo" />
  </a>
  

  <!-- <canvas #gradientCanvas id="gradient-canvas" *ngIf="agentsSettings && agentsSettings.agents_back_type == 'gradient'"></canvas> -->
  <canvas #gradientCanvas id="gradient-canvas"></canvas>
  
  <div *ngIf="agentsSettings && agentsSettings.agents_back_type == 'image'" class="bck-img-wrapper" [style.background-color]="agentsSettings?.agents_bck_fullcolor">
    <img [src]="backgroundImg"/>
  </div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>